var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{class:[_vm.icon, 'fa-fw'],attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.file.displayName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }